import { Link } from "react-router-dom";
import styled from "styled-components";

export const Button = styled.button`
  border-radius: 15px;
  padding: 2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.color.tertiaryLight};
  color: ${(props) => props.theme.color.primaryDark};
  border: ${(props) => `4px solid ${props.theme.color.primaryDark}`};
  font-size: ${(props) => props.theme.font.size.title.big};
  height: 5rem;
  width: 100%;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PurpleButton = styled(Button)`
  background: ${(props) => props.theme.color.primary};
  color: ${(props) => props.theme.color.tertiaryLight};
  font-family: ${(props) => props.theme.font.family.title};
`;

export const TertiaryButton = styled(Button)`
  background: ${(props) => props.theme.color.tertiary};
  color: ${(props) => props.theme.color.tertiaryLight};
  border-color: ${(props) => props.theme.color.tertiaryLight};
`;

export const TertiaryFitContentButton = styled(TertiaryButton)`
  width: unset;
`;

export const PrimaryFitContentButton = styled(Button)`
  background: ${(props) => props.theme.color.primary};
  color: ${(props) => props.theme.color.tertiaryLight};
  border-color: ${(props) => props.theme.color.tertiaryLight};
  width: unset;
`;

export const SwitchButton = styled.div<{ checked: boolean; size: number }>`
  width: ${(props) => 40 * props.size}px;
  height: ${(props) => 20 * props.size}px;
  background: ${(props) => (props.checked ? props.theme.color.primary : "#ccc")};
  border-radius: 100px;
  position: relative;
  cursor: pointer;

  &::after {
    content: "";
    position: absolute;
    top: ${(props) => 2 * props.size}px;
    left: ${(props) => (props.checked ? 22 * props.size : 2 * props.size)}px;
    width: ${(props) => 16 * props.size}px;
    height: ${(props) => 16 * props.size}px;
    background: ${(props) => props.theme.color.tertiaryLight};
    border-radius: 100%;
    transition: 0.3s;
  }
`;

export const RoundCta = styled.button<{
  $color?: string;
  $background?: string;
  $textAlign?: string;
}>`
  width: 100%;
  border-radius: 100px;
  color: ${(props) => props.$color};
  background: ${(props) => props.$background};
  text-align: ${(props) => props.$textAlign ?? "center"};
  padding: 1rem;
  font-family: ${(props) => props.theme.font.family.main};
  font-size: ${(props) => props.theme.font.size.title.small};
  cursor: pointer;
  border: none;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const RoundBigTextCta = styled(RoundCta)`
  font-size: ${(props) => props.theme.font.size.title.big};
  text-shadow: ${(props) => props.theme.font.elevation.medium};
`;

export const TertiaryRoundBigTextCta = styled(RoundBigTextCta)`
  font-size: ${(props) => props.theme.font.size.title.big};
  text-shadow: ${(props) => props.theme.font.elevation.medium};
  background: ${(props) => props.theme.color.tertiary};
  color: ${(props) => props.theme.color.tertiaryLight};
`;

export const BallButton = styled.div<{
  $position: "right" | "left";
  $color?: string;
}>`
  border-radius: 100px;
  background-color: ${(props) => props.$color ?? props.theme.color.primary};
  width: 3rem;
  height: 3rem;
  font-size: ${(props) => props.theme.font.size.title.medium};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.7rem;
  > svg {
    width: 100%;
    height: 100%;
    transform: ${(props) => (props.$position == "left" ? "rotateZ(180deg)" : null)};
  }
`;

export const NavItem = styled(Link)`
  width: 3rem;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    height: 100%;
  }
`;
